import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UtilService} from '../../service/util.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(private http: HttpClient, private util: UtilService) {
  }

  ngOnInit(): void {
  }

}
